<template>
  <div class="modal" :class="{'is-active': opened}">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Item</p>
        <button class="delete" @click="close"></button>
      </header>
      <section class="modal-card-body">

        <div class="field" v-for="(f, i) in itemSchema" :key="'f-'+i">
          <label class="label">{{ f.label }} <span class="has-text-danger" v-if="f.required">*</span></label>
          <div v-if="f.options" class="control model-select-container">
            <model-select :options="f.options" v-model="newItem[f.name]" />
          </div>
          <div v-if="!f.options && f.type=='string'" class="control">
            <input class="input" type="text" v-model="newItem[f.name]">
          </div>
          <div v-if="!f.options && f.type=='number'" class="control">
            <input class="input" type="number" v-model.number="newItem[f.name]">
          </div>
        </div>

      </section>
      <footer class="modal-card-foot">
        <a class="button is-link" :class="{'is-loading': waiting}" :disabled="!changed || !valid" @click="saveItem">Save</a>
        <a class="button" @click="close">Cancel</a>
      </footer>
    </div>
  </div>
</template>
  
<script>
import { ModelSelect } from 'vue-search-select'

export default {
  name: 'item-modal',
  components: {
    ModelSelect
  },
  props: ['opened', 'item', 'itemSchema', 'items'],
  data () {
    return {
      error: '',
      waiting: false,
      newItem: {},
    }
  },
  computed: {
    changed () {
      if (!this.item) {
        return true
      }
      for (var f of this.itemSchema) {
        if (this.item[f.name] != this.newItem[f.name]) {
          return true
        }
      }
      return false
    },
    totals () {
      var totals = {}
      if (!this.items) {
        return totals
      }
      for (var i=0;i<this.itemSchema.length;i++) {
        var c = this.itemSchema[i]
        if (c.type === 'number') {
          var sum = 0
          for (var j=0;j<this.items.length;j++) {
            sum += this.items[j][c.name]
          }
          totals[c.name] = sum
        }
      }
      return totals
    },
    valid () {
      if (!this.newItem) {
        return false
      }
      for (var f of this.itemSchema) {
        if (f.required && !this.newItem[f.name]) {
          return false
        }
      }
      return true
    },
  },
  watch: {
    opened: function (val) {
      if (val) {
        if (this.item) {
          this.newItem = JSON.parse(JSON.stringify(this.item))
        } else {
          var newItem = {}
          for (var f of this.itemSchema) {
            if (f.type == 'number') {
              if (f.total && this.totals && f.total > this.totals[f.name]) {
                newItem[f.name] = f.total - this.totals[f.name]
              } else {
                newItem[f.name] = f.defaultValue || 0
              }
            } else if (f.copyPre && this.items && this.items.length) {
              newItem[f.name] = this.items[this.items.length - 1][f.name]
            } else {
              newItem[f.name] = f.defaultValue || ''
            }
          }
          console.log('itemSchema', this.itemSchema)
          console.log('newItem', newItem)
          this.newItem = newItem
        }
      }
    }
  },
  methods: {
    close () {
      this.$emit('closeItemModal', false)
    },
    saveItem () {
      if (!this.changed || !this.valid) {
        return
      }
      this.$emit('closeItemModal', JSON.parse(JSON.stringify(this.newItem)))
    },
  },
}
</script>

<style scoped>
.model-select-container {
  .ui {
    height: 100%;
  }
  .menu {
    z-index: 9000;
  }
}
</style>